import { createWrittenAccountPreviews } from "./WrittenAccountPreviews";

export const WrittenAccountPreviewsClosed = createWrittenAccountPreviews(
	"written_accounts_closed",
	(account) =>
		account.hasBeenActive && (account.status === "closed" || account.status === "declined"),
);
